module.exports = __webpack_public_path__ + "static/media/1.02dee935.svg";